export const vertexShader = `
  attribute vec2 aOriginalUv;
  
  uniform sampler2D uTexture;
  uniform float uPointSize;
  uniform float uPixelRatio;
  uniform float uBlackCutoff;
  
  varying vec3 vColor;
  varying vec2 vUv;
  
  void main() {
    vUv = aOriginalUv;
    
    // Sample texture color
    vec4 texColor = texture2D(uTexture, aOriginalUv);
    vColor = texColor.rgb;
    
    // Use updated position (modified by CPU physics)
    vec4 mvPosition = modelViewMatrix * vec4(position, 1.0);
    gl_Position = projectionMatrix * mvPosition;
    
    gl_PointSize = uPointSize * uPixelRatio;

    // Calculate source brightness (luminance) for culling
    float luminance = dot(vColor, vec3(0.299, 0.587, 0.114));
    
    // Cull transparent or dark pixels
    if (texColor.a < 0.1 || luminance < uBlackCutoff) {
      gl_PointSize = 0.0;
    }
  }
`;
